module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.00062","quantity":0.00001},{"color":"#9dc4b5","label":" 0.00062- 0.94029","quantity":0.0094},{"color":"#e6efc3","label":" 0.94029- 1.86609","quantity":0.01866},{"color":"#ffe89e","label":" 1.86609- 3.04389","quantity":0.03044},{"color":"#f5af7f","label":" 3.04389- 4.89994","quantity":0.049},{"color":"#ed6d32","label":" 4.89994- 21.12981","quantity":0.2113}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/cfxssl_raster/wheat_MME_1981_2016_lcr_90.json
// module id = HYlk
// module chunks = 171